var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup288(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.9242,
    cy: 13,
    r: 12.375,
    fill: "black",
    fillOpacity: 0.5,
    stroke: "#F4BB2B",
    strokeWidth: 0.45
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9242 5.64996L9.05609 7.90156L10.4782 8.73252L12.9236 7.31312L15.3701 8.73252L16.7922 7.90156L12.9242 5.64996ZM15.3695 9.90942L16.7922 10.741V12.4047L14.3462 13.8248V16.6648L12.9242 17.4964L11.5021 16.6648V13.8248L9.05609 12.4047V10.741L10.4782 9.90942L12.9236 11.3294L15.3701 9.90942H15.3695ZM16.7922 13.581V15.2448L15.3701 16.0764V14.4126L16.7922 13.5816V13.581ZM15.3561 17.2527L17.8015 15.8326V12.9932L19.2241 12.161V16.6648L15.3561 18.9164V17.2527ZM17.8015 10.1531L16.38 9.32158L17.8021 8.48939L19.2241 9.32158V10.9854L17.8021 11.8169L17.8015 10.1531ZM11.5027 19.519V17.8546L12.9248 18.6862L14.3468 17.8546V19.5184L12.9248 20.35L11.5027 19.5184V19.519ZM10.477 16.0758L9.05609 15.2448V13.581L10.4782 14.4126V16.0764L10.477 16.0758ZM12.9236 10.1525L11.5015 9.32158L12.9236 8.48939L14.3457 9.32158L12.9236 10.1531V10.1525ZM9.46833 9.32158L8.04623 10.1531V11.8169L6.62415 10.9854V9.32158L8.04623 8.48939L9.46833 9.32158ZM6.62415 12.161L8.04623 12.9932V15.8326L10.4916 17.2527V18.9164L6.62476 16.6648V12.161H6.62415Z",
    fill: "#F4BB2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup288);
export default __webpack_public_path__ + "static/media/Group 288.cf44652a6cda085b05eab9bd9d2e0ecd.svg";
export { ForwardRef as ReactComponent };